import React from "react";

export default function HomeMarqueeSection() {
  return (
    <div className="bg-primary/5 border-y border-primary/10 py-4 marquee-wrapper">
      <div className="marquee-track">
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            verified
          </span>
          Background-Checked Runners
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            location_on
          </span>
          Live GPS Tracking
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            lock
          </span>
          Escrow Payments
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            star
          </span>
          4.9 Avg. Runner Rating
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            support_agent
          </span>
          24/7 Customer Support
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            timer
          </span>
          Avg. 18 min Delivery
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            shield
          </span>
          Delivery Insurance
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            chat
          </span>
          In-App Messaging
        </span>
        <span className="sep-dot" />
        {/* duplicate */}
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            verified
          </span>
          Background-Checked Runners
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            location_on
          </span>
          Live GPS Tracking
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            lock
          </span>
          Escrow Payments
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            star
          </span>
          4.9 Avg. Runner Rating
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            support_agent
          </span>
          24/7 Customer Support
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            timer
          </span>
          Avg. 18 min Delivery
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            shield
          </span>
          Delivery Insurance
        </span>
        <span className="sep-dot" />
        <span className="marquee-item inline-flex items-center gap-2 text-sm font-bold text-slate-600">
          <span
            className="material-symbols-outlined text-primary text-base"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            chat
          </span>
          In-App Messaging
        </span>
        <span className="sep-dot" />
      </div>
    </div>
  );
}
